import { useState } from "react";
import { Paper, Container, Stack, TextField, Button, Typography } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import firebaseConfig from "../firebase"
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';
function AnnounceUpdate() {
  const db = getFirestore(firebaseConfig)
  const navigate = useNavigate()
  const {id} : {id: string} = useParams();
  const {update} = useSelector(state=>({...state }))
  const [announceImg, setImage] = useState(update.announceImg);
  const [announceLink, setLink] = useState(update.announceLink);
  const [announceStatus, setStatus] = useState(update.announceStatus);

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setImage(base64);
    console.log(base64)
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const update_an = async () => {
    const anRef = doc(db, "Announce", id);
    await updateDoc(anRef, {
      announceImg: announceImg,
      announceLink: announceLink,
      announceStatus: announceStatus
    });
    alert("บันทึกเรียบร้อย")
    navigate('/announce');
  }; 



  return (
    <Container class={Paper}>
      <Stack spacing={3}>
      <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          แก้ไขประกาศ
        </Typography>
        <input type="file" 
        onChange={(e) => {
          uploadImage(e);
        }}/>
        {/* <TextField inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="image*"
          onChange={(event) => {
            setImage(event.target.value);
          }}
          value={announceImg} /> */}
        <TextField inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="link*"
          onChange={(event) => {
            setLink(event.target.value);
          }}
          value={announceLink} />
        <TextField inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="status*"
          onChange={(event) => {
            setStatus(event.target.value);
          }}
          value={announceStatus} />
        <Stack direction="row" justifyContent="flex-end" spacing={3}>
        <Button  sx={{ fontFamily:'Prompt'}}   onClick={() => navigate('/announce')} variant="text" color="error">ยกเลิก</Button>
          <Button sx={{ fontFamily:'Prompt'}} onClick={update_an} variant="outlined" color="success"> บันทึก </Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default AnnounceUpdate